import { useMemo } from 'react';
import { ProductOfferType, USProductOffer } from 'types';

export const useUSProductOffers = ({
  productOffers,
  bankId,
  productId,
  featured = [],
  inactive = [],
}: {
  productOffers: Array<USProductOffer>;
  bankId?: string;
  productId?: string;
  featured?: string[];
  inactive?: string[];
}) => {
  const filteredData: Record<ProductOfferType | 'FEATURED', USProductOffer[]> = useMemo(
    () =>
      productOffers.reduce(
        (acc, item) => {
          if (productId?.trim() && item.id !== productId) {
            return acc;
          }

          if (bankId?.trim() && item.productBank.id !== bankId) {
            return acc;
          }

          if (inactive.includes(item.id)) {
            return acc;
          }

          if (featured.includes(item.id)) {
            acc.FEATURED.push(item);
          }

          acc[item.type].push(item);
          return acc;
        },
        {
          FEATURED: [] as USProductOffer[],
          SAVINGS_ACCOUNT: [] as USProductOffer[],
          HIGH_YIELD_CD: [] as USProductOffer[],
          NO_PENALTY_CD: [] as USProductOffer[],
        },
      ),
    [productOffers, bankId, inactive, featured, productId],
  );

  return {
    ...filteredData,
  };
};
